import './static-map.scss';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

class StaticMap {
    constructor (element) {
        this.$staticMap = element;
        this.mapID = 'static-map';
        this.map = null;
        this.marker = [];
        this.shipIcon = this.$staticMap.dataset.shipIcon;
        this.$activePopup = null;
        this.$activeMarker = null;
        this.worldGeoJsonUrl = this.$staticMap.dataset.staticMapJson;
        this.boundsArr = [];
        this.language = document.documentElement.lang;
    }

    initialize () {
        this.initMap(() => {
            this.setEvents();
        });
    }

    initMap (callback) {
        this.map = L.map(this.mapID, {
            closePopupOnClick: false,
            dragging: true,
            style: 'lightmode simplified',
            zoomSnap: 0.7,
            maxZoom: 10,
            // zoomDelta: 0.1,
            trackResize: false,
            scrollWheelZoom: false
        }).setView([51.505, -0.09], 2);

        const tilesURL = (this.language === 'de') ? 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png' : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

        L.tileLayer(tilesURL, {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        if (typeof callback === 'function') {
            callback();
        }
    }

    setEvents () {
        this.map.whenReady(() => {
            if (staticMapsShips) { // eslint-disable-line
                this.setMarker();
                if (staticMapsShips.length > 1) { // eslint-disable-line
                    this.map.fitBounds(this.boundsArr);
                } else {
                    if (staticMapsShips.length > 0) { // eslint-disable-line
                        const lat = staticMapsShips[0]?.position.lat; // eslint-disable-line
                        const lng = staticMapsShips[0]?.position.lng; // eslint-disable-line

                        if (lat && lng) {
                            this.map.zoomIn(3.5);

                            setTimeout(() => {
                                this.map.setView({lat: lat, lng: lng}); // eslint-disable-line
                            }, 1000);
                        }
                    }
                }
            }
        });
    }

    setMarker () {
        staticMapsShips.forEach((ship) => { // eslint-disable-line
            const shipIcon = L.divIcon({
                className: 'static-map__marker-icon',
                html: '<svg width="44" height="49" viewBox="0 0 44 49" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<rect width="44" height="44" rx="22" fill="#00305A"/>\n' +
                    '<path d="M30.53 30.66C29.27 30.66 28.19 30.05 28.05 29.31L29.99 23.15C30.0265 23.0279 30.016 22.8965 29.9605 22.7817C29.9049 22.6669 29.8085 22.5771 29.69 22.53L27.89 21.86L27 17.4C26.9777 17.2904 26.9193 17.1913 26.8341 17.1188C26.7489 17.0463 26.6418 17.0045 26.53 17H25.67L26.01 15.62C26.0303 15.5463 26.0327 15.4689 26.0171 15.3941C26.0014 15.3193 25.9681 15.2493 25.92 15.19C25.8739 15.1305 25.8148 15.0824 25.7472 15.0495C25.6795 15.0165 25.6052 14.9996 25.53 15H25.03V14C25.03 13.8674 24.9773 13.7402 24.8836 13.6464C24.7898 13.5527 24.6626 13.5 24.53 13.5C24.3974 13.5 24.2702 13.5527 24.1764 13.6464C24.0827 13.7402 24.03 13.8674 24.03 14V15H23.03V13.5C23.03 13.3674 22.9773 13.2402 22.8836 13.1464C22.7898 13.0527 22.6626 13 22.53 13H20.53C20.3974 13 20.2702 13.0527 20.1764 13.1464C20.0827 13.2402 20.03 13.3674 20.03 13.5V15H19.03V14C19.03 13.8674 18.9773 13.7402 18.8836 13.6464C18.7898 13.5527 18.6626 13.5 18.53 13.5C18.3974 13.5 18.2702 13.5527 18.1764 13.6464C18.0827 13.7402 18.03 13.8674 18.03 14V15H17.53C17.4548 14.9996 17.3805 15.0165 17.3128 15.0495C17.2452 15.0824 17.1861 15.1305 17.14 15.19C17.0919 15.2493 17.0586 15.3193 17.0429 15.3941C17.0273 15.4689 17.0297 15.5463 17.05 15.62L17.39 17H16.53C16.4147 17 16.303 17.0398 16.2137 17.1127C16.1244 17.1856 16.0631 17.2871 16.04 17.4L15.15 21.86L13.35 22.53C13.2315 22.5771 13.1351 22.6669 13.0795 22.7817C13.024 22.8965 13.0135 23.0279 13.05 23.15L14.99 29.31C14.85 30.05 13.77 30.66 12.51 30.66C12.4435 30.6587 12.3774 30.6706 12.3156 30.6952C12.2538 30.7197 12.1975 30.7563 12.15 30.8029C12.1025 30.8494 12.0647 30.905 12.039 30.9663C12.0132 31.0276 12 31.0935 12 31.16C12.0026 31.2935 12.0575 31.4207 12.1529 31.5142C12.2482 31.6077 12.3765 31.66 12.51 31.66C13.0366 31.6763 13.5612 31.5884 14.0537 31.4013C14.5463 31.2142 14.997 30.9317 15.38 30.57C15.38 30.52 15.48 30.49 15.51 30.44C15.8237 30.7954 16.2133 31.0756 16.65 31.26C16.8745 31.3638 17.109 31.4443 17.35 31.5C17.732 31.6007 18.1249 31.6544 18.52 31.66C18.9151 31.6551 19.3081 31.6014 19.69 31.5C20.401 31.3528 21.046 30.9813 21.53 30.44C22.014 30.9813 22.659 31.3528 23.37 31.5C23.7519 31.6014 24.1449 31.6551 24.54 31.66C24.9351 31.6544 25.328 31.6007 25.71 31.5C25.951 31.4443 26.1855 31.3638 26.41 31.26C26.8395 31.0731 27.2221 30.793 27.53 30.44C27.53 30.44 27.62 30.52 27.66 30.57C28.043 30.9317 28.4937 31.2142 28.9863 31.4013C29.4788 31.5884 30.0034 31.6763 30.53 31.66C30.6635 31.66 30.7918 31.6077 30.8871 31.5142C30.9825 31.4207 31.0374 31.2935 31.04 31.16C31.04 31.0935 31.0268 31.0276 31.001 30.9663C30.9753 30.905 30.9375 30.8494 30.89 30.8029C30.8425 30.7563 30.7862 30.7197 30.7244 30.6952C30.6626 30.6706 30.5965 30.6587 30.53 30.66ZM21.03 14H22.03V15H21.03V14ZM18.17 16H24.89L24.64 17H18.42L18.17 16ZM16.94 18H26.12L26.81 21.45L21.71 19.5C21.5933 19.4604 21.4667 19.4604 21.35 19.5L16.25 21.5L16.94 18ZM14.15 23.3L15.24 22.89L17.62 22L21.53 20.5L25.44 21.97L27.82 22.86L28.91 23.27L28.53 24.61L21.67 23.05C21.598 23.03 21.522 23.03 21.45 23.05L14.53 24.61L14.15 23.3ZM27.01 29.38V29.5C26.743 29.9024 26.3703 30.2235 25.9328 30.4282C25.4954 30.6328 25.01 30.713 24.53 30.66C23.17 30.66 22.02 29.97 22.02 29.15C22.02 29.0174 21.9673 28.8902 21.8736 28.7964C21.7798 28.7027 21.6526 28.65 21.52 28.65C21.3874 28.65 21.2602 28.7027 21.1664 28.7964C21.0727 28.8902 21.02 29.0174 21.02 29.15C21.02 29.97 19.87 30.66 18.51 30.66C18.0396 30.7017 17.5667 30.616 17.1409 30.4119C16.7151 30.2078 16.3521 29.8928 16.09 29.5V29.38L15.92 28.81L14.92 25.57L21.53 24.05L28.2 25.57L27.2 28.81L27.01 29.38Z" fill="white"/>\n' +
                    '<rect x="22" y="35" width="10" height="10" rx="2" transform="rotate(45 22 35)" fill="#00305A"/>\n' +
                    '</svg><span>' + ship.name + '</span>',
                iconSize: [44, 49],
                iconAnchor: [22, 49]
            });

            const shipIconActive = L.divIcon({
                className: 'static-map__marker-icon',
                html: '<svg width="44" height="49" viewBox="0 0 44 49" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<rect width="44" height="44" rx="22" fill="#EB5C25"/>\n' +
                    '<path d="M30.53 30.66C29.27 30.66 28.19 30.05 28.05 29.31L29.99 23.15C30.0265 23.0279 30.016 22.8965 29.9605 22.7817C29.9049 22.6669 29.8085 22.5771 29.69 22.53L27.89 21.86L27 17.4C26.9777 17.2904 26.9193 17.1913 26.8341 17.1188C26.7489 17.0463 26.6418 17.0045 26.53 17H25.67L26.01 15.62C26.0303 15.5463 26.0327 15.4689 26.0171 15.3941C26.0014 15.3193 25.9681 15.2493 25.92 15.19C25.8739 15.1305 25.8148 15.0824 25.7472 15.0495C25.6795 15.0165 25.6052 14.9996 25.53 15H25.03V14C25.03 13.8674 24.9773 13.7402 24.8836 13.6464C24.7898 13.5527 24.6626 13.5 24.53 13.5C24.3974 13.5 24.2702 13.5527 24.1764 13.6464C24.0827 13.7402 24.03 13.8674 24.03 14V15H23.03V13.5C23.03 13.3674 22.9773 13.2402 22.8836 13.1464C22.7898 13.0527 22.6626 13 22.53 13H20.53C20.3974 13 20.2702 13.0527 20.1764 13.1464C20.0827 13.2402 20.03 13.3674 20.03 13.5V15H19.03V14C19.03 13.8674 18.9773 13.7402 18.8836 13.6464C18.7898 13.5527 18.6626 13.5 18.53 13.5C18.3974 13.5 18.2702 13.5527 18.1764 13.6464C18.0827 13.7402 18.03 13.8674 18.03 14V15H17.53C17.4548 14.9996 17.3805 15.0165 17.3128 15.0495C17.2452 15.0824 17.1861 15.1305 17.14 15.19C17.0919 15.2493 17.0586 15.3193 17.0429 15.3941C17.0273 15.4689 17.0297 15.5463 17.05 15.62L17.39 17H16.53C16.4147 17 16.303 17.0398 16.2137 17.1127C16.1244 17.1856 16.0631 17.2871 16.04 17.4L15.15 21.86L13.35 22.53C13.2315 22.5771 13.1351 22.6669 13.0795 22.7817C13.024 22.8965 13.0135 23.0279 13.05 23.15L14.99 29.31C14.85 30.05 13.77 30.66 12.51 30.66C12.4435 30.6587 12.3774 30.6706 12.3156 30.6952C12.2538 30.7197 12.1975 30.7563 12.15 30.8029C12.1025 30.8494 12.0647 30.905 12.039 30.9663C12.0132 31.0276 12 31.0935 12 31.16C12.0026 31.2935 12.0575 31.4207 12.1529 31.5142C12.2482 31.6077 12.3765 31.66 12.51 31.66C13.0366 31.6763 13.5612 31.5884 14.0537 31.4013C14.5463 31.2142 14.997 30.9317 15.38 30.57C15.38 30.52 15.48 30.49 15.51 30.44C15.8237 30.7954 16.2133 31.0756 16.65 31.26C16.8745 31.3638 17.109 31.4443 17.35 31.5C17.732 31.6007 18.1249 31.6544 18.52 31.66C18.9151 31.6551 19.3081 31.6014 19.69 31.5C20.401 31.3528 21.046 30.9813 21.53 30.44C22.014 30.9813 22.659 31.3528 23.37 31.5C23.7519 31.6014 24.1449 31.6551 24.54 31.66C24.9351 31.6544 25.328 31.6007 25.71 31.5C25.951 31.4443 26.1855 31.3638 26.41 31.26C26.8395 31.0731 27.2221 30.793 27.53 30.44C27.53 30.44 27.62 30.52 27.66 30.57C28.043 30.9317 28.4937 31.2142 28.9863 31.4013C29.4788 31.5884 30.0034 31.6763 30.53 31.66C30.6635 31.66 30.7918 31.6077 30.8871 31.5142C30.9825 31.4207 31.0374 31.2935 31.04 31.16C31.04 31.0935 31.0268 31.0276 31.001 30.9663C30.9753 30.905 30.9375 30.8494 30.89 30.8029C30.8425 30.7563 30.7862 30.7197 30.7244 30.6952C30.6626 30.6706 30.5965 30.6587 30.53 30.66ZM21.03 14H22.03V15H21.03V14ZM18.17 16H24.89L24.64 17H18.42L18.17 16ZM16.94 18H26.12L26.81 21.45L21.71 19.5C21.5933 19.4604 21.4667 19.4604 21.35 19.5L16.25 21.5L16.94 18ZM14.15 23.3L15.24 22.89L17.62 22L21.53 20.5L25.44 21.97L27.82 22.86L28.91 23.27L28.53 24.61L21.67 23.05C21.598 23.03 21.522 23.03 21.45 23.05L14.53 24.61L14.15 23.3ZM27.01 29.38V29.5C26.743 29.9024 26.3703 30.2235 25.9328 30.4282C25.4954 30.6328 25.01 30.713 24.53 30.66C23.17 30.66 22.02 29.97 22.02 29.15C22.02 29.0174 21.9673 28.8902 21.8736 28.7964C21.7798 28.7027 21.6526 28.65 21.52 28.65C21.3874 28.65 21.2602 28.7027 21.1664 28.7964C21.0727 28.8902 21.02 29.0174 21.02 29.15C21.02 29.97 19.87 30.66 18.51 30.66C18.0396 30.7017 17.5667 30.616 17.1409 30.4119C16.7151 30.2078 16.3521 29.8928 16.09 29.5V29.38L15.92 28.81L14.92 25.57L21.53 24.05L28.2 25.57L27.2 28.81L27.01 29.38Z" fill="white"/>\n' +
                    '<rect x="22" y="35" width="10" height="10" rx="2" transform="rotate(45 22 35)" fill="#EB5C25"/>\n' +
                    '</svg><span>' + ship.name + '</span>',
                iconSize: [44, 49],
                iconAnchor: [22, 49]
            });

            const marker = L.marker([ship.position.lat, ship.position.lng], {
                icon: shipIcon,
                id: ship.id,
                activeIcon: shipIconActive,
                defaultIcon: shipIcon,
                alt: ship.name + 'position marker',
                riseOnHover: true
            }).addTo(this.map);

            this.boundsArr.push([ship.position.lat, ship.position.lng]);
            this.marker.push(marker);

            this.setMarkerEvents(marker);
        });
    }

    setMarkerEvents (marker) {
        const $popup = this.$staticMap.querySelector('[data-ship-id="' + marker.options.id + '"]');
        const $closeButton = $popup.querySelector('[data-ship-popup="close"]');

        marker.on('click', () => {
            if ($popup !== this.$activePopup) {
                if (this.$activePopup !== null) {
                    this.$activePopup.classList.add('is--hidden');
                    this.$activeMarker.setIcon(this.$activeMarker.options.defaultIcon);
                    this.$activePopup = null;
                    this.$activeMarker = null;

                    setTimeout(() => {
                        $popup.classList.remove('is--hidden');
                        this.map.panTo(marker.getLatLng());
                        this.$activePopup = $popup;
                        this.$activeMarker = marker;
                        marker.setIcon(marker.options.activeIcon);
                    }, 250);
                } else {
                    $popup.classList.remove('is--hidden');
                    this.map.panTo(marker.getLatLng());
                    this.$activePopup = $popup;
                    this.$activeMarker = marker;
                    marker.setIcon(marker.options.activeIcon);
                }
            } else {
                this.$activePopup.classList.add('is--hidden');
                this.$activeMarker.setIcon(this.$activeMarker.options.defaultIcon);
                this.$activePopup = null;
                this.$activeMarker = null;
            }
        });

        $closeButton.addEventListener('click', () => {
            $popup.classList.add('is--hidden');
            this.$activeMarker.setIcon(this.$activeMarker.options.defaultIcon);
            this.$activeMarker = null;
            this.$activePopup = null;
        });
    }
}

export { StaticMap };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $staticMap = $context.querySelector('[data-static-map="root"]');

        if ($staticMap) {
            const initializeMap = ($placeholder) => {
                const staticMap = new StaticMap($staticMap);
                staticMap.initialize();

                if ($placeholder) {
                    $placeholder.remove();
                }
            };

            const $placeholder = $staticMap.querySelector('.media__restriction');

            const waitForConsent = setInterval(() => {
                if (typeof OneTrust !== 'undefined') { // eslint-disable-line
                    let mapAllowed = OnetrustActiveGroups.indexOf('C0009') !== -1; // eslint-disable-line

                    if (OnetrustActiveGroups.indexOf('C0009') != -1) { // eslint-disable-line
                        initializeMap($placeholder);
                    } else {
                        const $button = $staticMap.querySelector('[data-restriction="remove"]');

                        if ($button) {
                            $button.addEventListener('click', () => {
                                if (typeof OneTrust.UpdateConsent !== 'undefined') { // eslint-disable-line
                                    OneTrust.UpdateConsent("Category","C0009:1"); // eslint-disable-line
                                } else {
                                    OneTrust.ToggleInfoDisplay(); // eslint-disable-line
                                }
                            });
                        }

                        if ($placeholder) {
                            $placeholder.classList.add('is--shown');
                            $placeholder.closest('[data-media="youtube"]')?.classList.add('has--restriction');
                        }
                    }

                    OneTrust.OnConsentChanged(() => { // eslint-disable-line
                        if (mapAllowed != (OnetrustActiveGroups.indexOf('C0009') !== -1)) {  // eslint-disable-line
                            mapAllowed = OnetrustActiveGroups.indexOf('C0009') !== -1; // eslint-disable-line

                            if ($placeholder && mapAllowed) {
                                initializeMap($placeholder);
                            } else {
                                setTimeout(() => {
                                    location.reload();
                                }, 500);
                            }
                        }
                    });

                    clearInterval(waitForConsent);
                }
            }, 300);
        }
    }
});
